import CustomModal from "Components/CustomModal/CustomModal";
import CountrySelectFilter from "Dashboard/Components/ModalFilter/Components/CountrySelectFilter";
import DatePickerInput from "Dashboard/Components/Ui/DatePickerInput/DatePickerInput";
import { useState } from "react";
import { Formik, Form, Field, ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import iconUpload from "../../../../assets/images/icons/upload.svg";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import HomeCountrySelect from "Components/CountrySelect/CountrySelect";
import CategorySelect from "Components/CountrySelect/CategorySelect";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import CountrySelect from "Components/Ui/CountrySelect/ReactSelectCountry";
import axiosInstance from "../../../../axios";
import { TimePicker } from "@mui/x-date-pickers";
import moment from "moment";

import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
registerPlugin(FilePondPluginImagePreview, FilePondPluginImageExifOrientation);

const ModalEditContent = ({id, showModalEdit, hideModalEdit,editItem }) => {
  // UPLOAD IMAGE
  const [files, setFiles] = useState([]);
  const [files1, setFiles1] = useState([]);
  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    setFiles([...files, ...selectedFiles]);
    formik.setFieldValue("file", event.currentTarget.files[0]);
  };
  const handleFileChange1 = (event) => {
    const selectedFiles = event.target.files;
    setFiles1([...files1, ...selectedFiles]);
    formik.setFieldValue("file1", event.currentTarget.files[0]);
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
  };
  const handleRemoveFile1 = (index) => {
    const updatedFiles = [...files1];
    updatedFiles.splice(index, 1);
    setFiles1(updatedFiles);
  };
const {t,i18n}=useTranslation()
  const validationSchema = Yup.object().shape({
    nameAr: Yup.string().required(
      `${i18n.language === "ar" ? "ادخل الأسم بالعربية" : "Enter Your Name in arabic"}`
    ),
    nameEn: Yup.string().required(
      `${i18n.language === "ar" ? "ادخل الأسم بالانجليزية" : "Enter Your Name in English"}`
    ),
    email: Yup.string()
      .email(`${i18n.language === "ar" ? "ايميل خطاء" : "Wrong email"}`)
      .required(
        `${
          i18n.language === "ar" ? "البريد الألكترونى مطلوب" : "Email required"
        }`
      ),
      website: Yup.string()
      .url(`${i18n.language === "ar" ? "الرابط مطلوب" : "Url required"}`)
      .required(
        `${
          i18n.language === "ar"
            ? "رابط المتجر او رابط علي منصات التواصل الاجتماعي"
            : "Store link or link on social media platforms"
        }`
      )
      ,
      phone:Yup.number()
      .typeError(
        `${
          i18n.language === "ar"
            ? "رقم الهاتف يجب أن يكون أرقامًا فقط"
            : "Phone number must be numbers only"
        }`
      )
      .positive(
        `${
          i18n.language === "ar"
            ? "رقم الهاتف يجب أن يكون إيجابيًا"
            : "Phone number must be positive"
        }`
      )
      .integer(
        `${
          i18n.language === "ar"
            ? "رقم الهاتف يجب أن يكون عدد صحيح"
            : "The phone number must be an integer"
        }`
      )
      .min(
        13,
        `${
          i18n.language === "ar"
            ? "رقم الهاتف قصير جدا!"
            : "The phone number is too short!"
        }`
      )
      .max(
        9999999999999,
        `${
          i18n.language === "ar"
            ? "رقم الهاتف غير صحيح!"
            : "Phone number is incorrect!"
        }`
      )
      .required(
        `${
          i18n.language === "ar" ? "رقم الهاتف مطلوب" : "Phone number required"
        }`
      ),
      file: Yup.mixed().required("File is required"),
      file1: Yup.mixed().required("File is required"),
  
      commercial_register: Yup.string().required("commercial register is required"),
      branch_count: Yup.number().required("branch count is required"),
  
  });
  const [countryId,setCountryId]=useState(null)
const [CateId,setCateId]=useState(null)

  // SELECT DATE
  const formik = useFormik({
    initialValues: {
      nameAr: "",
      nameEn: "",
      phone:editItem?.phone || "",
      email: editItem?.email || "",
      website: editItem?.website || "",
      file: null,
      file1: null,

      commercial_register: "",
      branch_count:"",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      SubmitHandler(values)
      
    }
  });

  const isNextDisabled =
  !formik.values.nameAr ||
  !formik.values.nameEn ||
 
  !formik.values.nameEn ||
  !formik.values.phone ||

  !formik.values.email ||
  !formik.values.website || !countryId ||
   !formik.values.file 
  ||!formik.values.file1 
  || !formik.values.commercial_register
  || !formik.values.branch_count

||!CateId;
const [loading,setLoading]=useState(false)
  const SubmitHandler = (values) => {
    setLoading(true)

    
      const formData = new FormData();
      formData.append("ar[title]", values.nameAr);
      formData.append("en[title]", values.nameEn);
      formData.append("email", values.email);
      formData.append("phone", values.phone);
      formData.append("website", values.website);
      formData.append("country_id", countryId?.value);
      formData.append("category_id", CateId?.value);
      formData.append("commercial_register", values.commercial_register);
      formData.append("branch_count", values.branch_count);
      formData.append("file", values.file);
      formData.append("file1", values.file1);


      
   

      


      axiosInstance
        .post(`/admin/store/update/${id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          setLoading(false)
          toast.success(t("Store Edited Successfully"));
          hideModalEdit()
        }).catch(err=>{
          setLoading(false)
          toast.error(err.response.data.message);
        });
    
  };
  return (
    <CustomModal
      show={showModalEdit}
      onHide={hideModalEdit}
      title={t("edit Store ")}
      newClass={"modal-edit-content"}
    >
       <form onSubmit={formik.handleSubmit}>
          <div
            className={`mb-3 ${
              formik.touched.nameAr && formik.errors.nameAr ? "is-invalid" : ""
            }`}
          >
            <label className="form-label">
              {i18n.language === "ar" ? " الاسم بالعربية" : "Yor Name in Arabic"}
            </label>
            <input
              type="text"
              name="nameAr"
              className={`form-control ${
                formik.touched.nameAr && formik.errors.nameAr
                  ? "is-invalid"
                  : formik.touched.nameAr && !formik.errors.nameAr
                  ? "is-valid"
                  : ""
              }`}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.nameAr}
              placeholder={
                i18n.language === "ar" ? "ادخل اسمك الثلاثي" : "Enter Your Name"
              }
            />
            {formik.touched.nameAr && formik.errors.nameAr && (
              <div className="invalid-feedback">{formik.errors.nameAr}</div>
            )}
          </div>
          <div
            className={`mb-3 ${
              formik.touched.nameEn && formik.errors.nameEn ? "is-invalid" : ""
            }`}
          >
            <label className="form-label">
              {i18n.language === "ar" ? " الاسم بالانجليزية" : "Yor Name in english"}
            </label>
            <input
              type="text"
              name="nameEn"
              className={`form-control ${
                formik.touched.nameEn && formik.errors.nameEn
                  ? "is-invalid"
                  : formik.touched.nameEn && !formik.errors.nameEn
                  ? "is-valid"
                  : ""
              }`}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.nameEn}
              placeholder={
                i18n.language === "ar" ? "ادخل اسمك الثلاثي" : "Enter Your Name"
              }
            />
            {formik.touched.nameEn && formik.errors.nameEn && (
              <div className="invalid-feedback">{formik.errors.nameEn}</div>
            )}
          </div>
          <div
            className={`mb-3 ${
              formik.touched.email && formik.errors.email ? "is-invalid" : ""
            }`}
          >
            <label className="form-label">
              {i18n.language === "ar" ? "البريد الإلكتروني" : "Your Email"}
            </label>
            <input
              type="email"
              name="email"
              className={`form-control ${
                formik.touched.email && formik.errors.email
                  ? "is-invalid"
                  : formik.touched.email && !formik.errors.email
                  ? "is-valid"
                  : ""
              }`}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              placeholder="mail@exmaple.com"
            />
            {formik.touched.email && formik.errors.email && (
              <div className="invalid-feedback">{formik.errors.email}</div>
            )}
          </div>
          <div
            className={`mb-3 ${
              formik.touched.website && formik.errors.website ? "is-invalid" : ""
            }`}
          >
            <label className="form-label">
              {i18n.language === "ar"
                ? "رابط المتجر او رابط علي منصات التواصل الاجتماعي"
                : "Store link or link on social media platforms"}
            </label>
            <input
              type="text"
              name="website"
              className={`form-control ${
                formik.touched.website && formik.errors.website
                  ? "is-invalid"
                  : formik.touched.website && !formik.errors.website
                  ? "is-valid"
                  : ""
              }`}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.website}
              placeholder="website"
            />
            {formik.touched.website && formik.errors.website && (
              <div className="invalid-feedback">{formik.errors.website}</div>
            )}
          </div>
          <div
              className={`mb-3 ${
                formik.touched.phone && formik.errors.phone
                  ? "is-invalid"
                  : ""
              }`}
            >
              <label className="form-label">
                {i18n.language === "ar"
                  ? "رقم الهاتف"
                  : "phone Number"}
              </label>
              <input
                type="number"
                name="phone"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phone}
                className={`form-control ${
                  formik.touched.phone && formik.errors.phone
                    ? "is-invalid"
                    : formik.touched.phone && !formik.errors.phone
                    ? "is-valid"
                    : ""
                }`}
                placeholder=  {i18n.language === "ar"
                  ? "رقم الهاتف"
                  : "phone Number"}
              />
              {formik.touched.phone && formik.errors.phone && (
                <div className="invalid-feedback">{formik.errors.phone}</div>
              )}
            </div>
          <div
            className={`mb-3 `}
          >
            <label className="form-label">
              {i18n.language === "ar" ? "اختر دولتك " : "choose your country"}
            </label>
            <HomeCountrySelect selectedCountry={editItem?.country?.id} width={'100%'} setValue={setCountryId} />
       
          </div>
          <div
            className={`mb-3 `}
          >
            <label className="form-label">
              {i18n.language === "ar" ? "اختر الفئة " : "choose your cateogry"}
            </label>
            <CategorySelect selectedCountry={editItem?.category?.id} width={'100%'} setValue={setCateId} />
       
          </div>
         {/* <CategorySelect /> */}
         <div
                className={`mb-3 ${
                  formik.touched.commercial_register && formik.errors.commercial_register
                    ? "is-invalid"
                    : ""
                }`}
              >
                <label className="form-label">
                  {i18n.language === "ar"
                    ? "رقم الترخيص التجاري"
                    : "Commercial license commercial_register"}
                </label>
                <input
                  type="number"
                  name="commercial_register"
                  className={`form-control ${
                    formik.touched.commercial_register && formik.errors.commercial_register
                      ? "is-invalid"
                      : formik.touched.commercial_register && !formik.errors.commercial_register
                      ? "is-valid"
                      : ""
                  }`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.commercial_register}
                  placeholder={
                    i18n.language === "ar"
                      ? "ادخل رقم الترخيص التجاري"
                      : "Enter the commercial license commercial_register"
                  }
                />
                {formik.touched.commercial_register && formik.errors.commercial_register && (
                  <div className="invalid-feedback">{formik.errors.commercial_register}</div>
                )}
              </div>

              <div
                className={`mb-3 upload-files ${
                  formik.touched.file && formik.errors.file ? "is-invalid" : ""
                }`}
              >
                <div className="file-upload-container">
                  <input
                    type="file"
                    id="fileInput"
                    accept=".png, .jpg, .jpeg"
                    onChange={handleFileChange}
                    multiple
                    name="file"
                    onBlur={formik.handleBlur}
                  />
                  <label
                    htmlFor="fileInput"
                    className="file-upload-label d-flex align-items-center justify-content-center flex-column gap-3 w-100"
                  >
                    <div className="icon-upload">
                      <img src={iconUpload} alt="icon upload" />
                    </div>
                    <div className="text">{`${
                      i18n.language === "ar"
                        ? "أرفق صورة الترخيص التجارى Pdf"
                        : "Attach a copy of the commercial license PDF"
                    }`}</div>
                  </label>

                  {files.length > 0 && (
                    <div className="file-preview">
                      {files.map((file, index) => (
                        <div className="main-image-file">
                          <div key={index} className="file-preview-item">
                            {file.type.includes("image") ? (
                              <div className="img-prev">
                                {" "}
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt={`Uploaded ${index}`}
                                />
                              </div>
                            ) : (
                              <p>{file.name}</p>
                            )}
                            <button
                              className="remove-button"
                              onClick={() => handleRemoveFile(index)}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {formik.touched.file && formik.errors.file && (
                  <div className="invalid-feedback">{formik.errors.file}</div>
                )}
              </div>
              <div
                className={`mb-3 upload-files ${
                  formik.touched.file1 && formik.errors.file1 ? "is-invalid" : ""
                }`}
              >
                <div className="file-upload-container">
                  <input
                    type="file"
                    id="fileInput1"
                    accept=".png, .jpg, .jpeg"
                    onChange={handleFileChange1}
                    multiple
                    name="file1"
                    onBlur={formik.handleBlur}
                  />
                  <label
                    htmlFor="fileInput1"
                    className="file-upload-label d-flex align-items-center justify-content-center flex-column gap-3 w-100"
                  >
                    <div className="icon-upload">
                      <img src={iconUpload} alt="icon upload" />
                    </div>
                    <div className="text">{`${
                      i18n.language === "ar"
                        ? "أرفق صورة شعار المتجر  "
                        : "Attach a copy of the store logo"
                    }`}</div>
                  </label>

                  {files1.length > 0 && (
                    <div className="file-preview">
                      {files1.map((file, index) => (
                        <div className="main-image-file">
                          <div key={index} className="file-preview-item">
                            {file.type.includes("image") ? (
                              <div className="img-prev">
                                {" "}
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt={`Uploaded ${index}`}
                                />
                              </div>
                            ) : (
                              <p>{file.name}</p>
                            )}
                            <button
                              className="remove-button"
                              onClick={() => handleRemoveFile1(index)}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {formik.touched.file1 && formik.errors.file1 && (
                  <div className="invalid-feedback">{formik.errors.file1}</div>
                )}
              </div>
              <div
                className={`mb-3 ${
                  formik.touched.branch_count && formik.errors.branch_count
                    ? "is-invalid"
                    : ""
                }`}
              >
                <label className="form-label">
                  {i18n.language === "ar"
                    ? "عدد الفروع  "
                    : "  number of branches"}
                </label>
                <input
                  type="number"
                  name="branch_count"
                  className={`form-control ${
                    formik.touched.branch_count && formik.errors.branch_count
                      ? "is-invalid"
                      : formik.touched.branch_count && !formik.errors.branch_count
                      ? "is-valid"
                      : ""
                  }`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.branch_count}
                  placeholder= {i18n.language === "ar"
                    ? "عدد الفروع  "
                    : "  number of branches"}
                />
                {formik.touched.branch_count && formik.errors.branch_count && (
                  <div className="invalid-feedback">{formik.errors.branch_count}</div>
                )}
              </div>
          <button
            type="submit"
            className="btn-main"
          
            disabled={isNextDisabled}
          >
            {i18n.language === "ar" ? "التالى" : "Next"}
          </button>
        </form>
    </CustomModal>
  );
};

export default ModalEditContent;
